// DS: C33C
/** Bottom section of a commission, containing related information
 *  https://zpl.io/2pvJMnN
 */

import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { getDeviationTitle } from '../../../_helpers';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import UserLink from '../../../../User/Link';
import UserAvatar from '../../../../User/Avatar';
import Timestamp from '../../../../Timestamp';
import PriceBlock from './PriceBlock';

import s from './PanelC33C.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  priceTextClassName?: string;
  price?: number;
  dollarsCost?: string;
  priceLabel?: string;
  priceLabelOnTop?: boolean;
  showAuthor?: boolean;
  showTimestamp?: boolean;
  addLink?: boolean;
}

const PanelC33C: React.FC<Props> = ({
  deviation,
  showAuthor = true,
  showTimestamp = true,
  addLink,
  className,
  ...priceProps
}) => {
  const hasAuthor = deviation.author && showAuthor;

  const renderTitleWithLink = () => (
    <DeviationLink
      deviation={deviation}
      className={classnames(s['title'], s['nowrap'])}
    >
      {getDeviationTitle(deviation)}
    </DeviationLink>
  );

  const title = addLink ? (
    renderTitleWithLink()
  ) : (
    <div
      className={classnames(s['title'], s['nowrap'])}
      title={getDeviationTitle(deviation)}
    >
      {getDeviationTitle(deviation)}
    </div>
  );
  return (
    <Flex className={classnames(s['root'], className)} alignItems="flex-start">
      <div className={s['left']}>
        {title}
        <Flex
          alignItems="center"
          className={classnames(
            s['author-block'],
            hasAuthor && s['has-author']
          )}
        >
          {hasAuthor && (
            <>
              <UserAvatar
                size={24}
                className={s['avatar']}
                user={deviation.author!}
              />
              <UserLink
                user={deviation.author!}
                className={classnames(s['userlink'], s['nowrap'])}
              />
            </>
          )}
          {showTimestamp && (
            <Timestamp
              timestamp={deviation.publishedTime}
              className={classnames(s['timestamp'], s['nowrap'])}
            />
          )}
        </Flex>
      </div>
      <PriceBlock {...priceProps} />
    </Flex>
  );
};
PanelC33C.displayName = 'PanelC33C';

export default PanelC33C;
